module.exports = __webpack_public_path__ + "static/media/IlotD_synthese_14.77f28e23.webp";